<vg-player (onPlayerReady)="onPlayerReady($event)">
  <ng-container *ngIf="isPlayerReady">
    <vg-overlay-play
      [vgFor]="identifier"
      [vgSkipIfControlsHidden]="true"
      [vgSkipIfControlsHiddenDelay]="0.1"
    ></vg-overlay-play>

    <vg-controls [vgAutohide]="true" [vgAutohideTime]="1">
      <vg-play-pause></vg-play-pause>
      <vg-mute></vg-mute>
      <vg-volume class="hidden md:flex"></vg-volume>

      <vg-scrub-bar>
        <vg-scrub-bar-current-time [vgFor]="identifier" [vgSlider]="true"></vg-scrub-bar-current-time>
      </vg-scrub-bar>

      <vg-time-display vgProperty="left" vgFormat="-mm:ss"></vg-time-display>

      <pl-button-switcher
        class="flex w-14 justify-center"
        *ngIf="playbackRateOptions.length > 1"
        [options]="playbackRateOptions"
      />

      <pl-menu-tooltip
        *ngIf="textTrackMenuItems.length > 1"
        [menuItems]="textTrackMenuItems"
        [menuIcon]="PlIcon.chatbox_ellipses_outline"
      />

      <pl-button-switcher
        class="flex w-11 justify-center"
        *ngIf="videoQualityOptions.length > 1"
        [options]="videoQualityOptions"
      />

      <vg-fullscreen></vg-fullscreen>
    </vg-controls>
  </ng-container>

  <video
    [vgMedia]="$any(vgMedia)"
    #vgMedia
    [id]="identifier"
    preload="auto"
    crossorigin="anonymous"
    class="video-player"
    [poster]="poster"
  >
    <source #vgMediaSource [src]="sourceSelectedByDefault" type="video/mp4" />

    <track
      *ngFor="let caption of captions"
      kind="subtitles"
      [label]="caption.label"
      [src]="caption.src"
      [srclang]="caption.lang"
      [attr.default]="caption.lang === textTrackSelectedByDefault ? '' : null"
    />
  </video>
</vg-player>
